/**
 * Created by Jan on 04.02.2018.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Helpers = Lfl.Helpers || {};

    (function (Helpers, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Helpers, 'Cookies')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Eases the access to cookies.
         *
         * @memberOf Lfl.Helpers
         */
        Lfl.Helpers.Cookies = Helpers.Cookies || {};

        (function (Cookies, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * Gets the cookie by it's name.
             * Source: https://stackoverflow.com/a/21125098/5500468 + comments
             * @memberOf Lfl.Helpers.Cookies
             * @return {String | boolean} Returns the string contained within the cookie or false if the cookie is not
             * found.
             */
            Cookies.getCookie = function (name) {
                var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                if (match) {
                    return match[2]
                } else {
                    return false;
                }
            };
            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
        }(Helpers.Cookies, jQuery));
    }(Lfl.Helpers, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));